import { type MutationHookOptions, useMutation } from "@apollo/client";
import { RequestVideoUploadMutation } from "../graphql/mutations";
import type {
  RequestVideoUploadMutationType,
  RequestVideoUploadMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useRequestVideoUploadMutation = (
  options?: MutationHookOptions<
    RequestVideoUploadMutationType,
    RequestVideoUploadMutationVariablesType
  >
) => {
  return useMutation<
    RequestVideoUploadMutationType,
    RequestVideoUploadMutationVariablesType
  >(RequestVideoUploadMutation, options);
};
